<template>
	<div class="page calculate-roving-bobbins-steering">
		<section id="navigation">
			<div class="container">
				<div class="content flex">
					<span @click="$router.go(-1);" class="go-back">
						<svg
							class="navigation-icon link-icon small"
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 14 20"
						>
							<path d="M.8 10L10.36.44 13.2 3.3 6.5 10l6.72 6.7-2.85 2.85L.8 10z" />
						</svg>
					</span>
					<span class="navigation-title">{{$t('calculate-roving-bobbins-steering')}}</span>
				</div>
			</div>
		</section>
		<transition name="slide-up" mode="out-in" appear>
			<section class="main" :key="$route.params.id">
				<form @submit.prvent="calc" ref="form">
					<div class="field">
						<div class="container">
							<div class="content">
								<div class="field-inner">
									<label for="spindle-number">{{$t('spindle-number')}}</label>
									<div class="element">
										<div class="flex">
											<input
												type="number"
												placeholder=" "
												min="1"
												step="any"
												id="spindle-number"
												v-model="spindleNumber"
											/>
										</div>
									</div>
									<label for="remaining-bobbins">{{$t('bobbins')}}</label>
									<div class="element">
										<div class="flex">
											<input
												type="number"
												placeholder=" "
												min="0"
												step="any"
												id="remaining-bobbins"
												v-model="remainingBobbins"
											/>
										</div>
									</div>
									<label for="bobbin-weight">{{$t('bobbins-weight')}}</label>
									<div class="element">
										<div class="flex">
											<input
												type="number"
												placeholder=" "
												min="0"
												step="any"
												id="bobbins-weight"
												v-model="bobbinsWeight"
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</form>
				<hr />
				<div class="container">
					<div class="content">
						<span class="result">{{parseInt(remainingBobbins/spindleNumber) || 0}} {{$tc('roving-bobbins-supplies', parseInt(remainingBobbins/spindleNumber) || 0)}}</span>
						<span class="result">{{remainingBobbins%spindleNumber || 0}} {{$t('bobbins-to-steer')}}</span>
						<!-- <span class="result">{{result | unit}} {{$t('gr-to-steer')}}</span> -->
						<!-- <button>{{$t('save')}}</button> -->
						<table class="grid">
							<tr :key="'steer-'+index" v-for="(steer, index) in toSteer">
								<td>{{$tc('roving-bobbins-supplies', 1)}} {{index + 1}}</td>
								<td>{{steer | unit}}</td>
							</tr>
						</table>
					</div>
				</div>
			</section>
		</transition>
	</div>
</template>

<script>
export default {
	data() {
		return {
			spindleNumber: '',
			remainingBobbins: '',
			bobbinsWeight: '',
			result: '',
			toSteer: [],
		};
	},
	mounted() {
		this.calc();
	},
	watch: {
		spindleNumber() {
			this.calc();
		},
		remainingBobbins() {
			this.calc();
		},
		bobbinsWeight() {
			this.calc();
		}
	},
	methods: {
		calc() {
			if (!this.$refs.form.checkValidity()) {
				// Try focus on the error
				this.$refs.form.reportValidity();
				return;
			}
			let spindleNumber = this.$utils.sanitize(this.spindleNumber);
			let remainingBobbins = this.$utils.sanitize(this.remainingBobbins);
			let bobbinsWeight = this.$utils.sanitize(this.bobbinsWeight);

			this.result = bobbinsWeight - (((spindleNumber - (remainingBobbins%spindleNumber)) / spindleNumber) * bobbinsWeight);
			this.result = this.$utils.sanitize(this.result);

			this.toSteer = [];
			if(this.result > 0) {
				let temp = bobbinsWeight - this.result;
				while (temp > 0){
					this.toSteer.push(temp);
					temp -= this.result;
				}
			}
		}
	},
	filters: {
		unit(value) {
			value = value || 0;
			return value.toFixed(3);
		}
	}
};
</script>